import { render, staticRenderFns } from "./AddPostLoginSurvey.vue?vue&type=template&id=35d2c829&scoped=true"
import script from "./AddPostLoginSurvey.vue?vue&type=script&lang=js"
export * from "./AddPostLoginSurvey.vue?vue&type=script&lang=js"
import style0 from "./AddPostLoginSurvey.vue?vue&type=style&index=0&id=35d2c829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2c829",
  null
  
)

export default component.exports